import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CouponRevelationFilterEntity } from '../../domain/entities/CouponRevelationFilterEntity'

export class CouponRevelationFilterModel extends CouponRevelationFilterEntity {
    userId?: string | null
    reveledFrom?: string | undefined
    reveledTo?: string | undefined

    constructor(dataDto: CouponRevelationFilterEntity) {
        super()
        mapEntityProperties<CouponRevelationFilterModel>(this, dataDto, {
            exclude: ['user' ,'reveledDate'],
            map: {
                  userId: dataDto?.user?.id || null,
                  reveledFrom: dataDto?.reveledDate?.[0] || undefined,
                  reveledTo: dataDto?.reveledDate?.[1] || undefined,
            }
        })
    }
}
